export function heroNewsContentParallax() {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
	if (prefersReducedMotion.matches) {
		return;
	}

	const heroes = Array.from(
		document.querySelectorAll('.strook-hero.hero-background-variant')
	);
	if (!heroes.length) {
		return;
	}

	const items = heroes
		.map((hero) => {
			const contentBlock = hero.querySelector('.last-item-mb-0');
			if (!(contentBlock instanceof HTMLElement)) {
				return null;
			}

			contentBlock.style.willChange = 'transform';

			return {
				hero,
				contentBlock
			};
		})
		.filter((item) => item !== null);

	if (!items.length) {
		return;
	}

	let rafId = 0;

	const update = () => {
		rafId = 0;
		const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;

		items.forEach(({ hero, contentBlock }) => {
			const rect = hero.getBoundingClientRect();
			if (rect.top > viewportHeight) {
				contentBlock.style.transform = 'translate3d(0, 0px, 0)';
				contentBlock.style.opacity = '1';
				return;
			}

			if (rect.bottom < 0) {
				const heroHeight = Math.max(rect.height, 1);
				const maxPinOffset = heroHeight * 0.32;
				contentBlock.style.transform = `translate3d(0, ${maxPinOffset.toFixed(2)}px, 0)`;
				contentBlock.style.opacity = '0.42';
				return;
			}

			const heroHeight = Math.max(rect.height, 1);
			const maxPinOffset = heroHeight * 0.32;
			let progress = 0;

			if (rect.top >= 0) {
				// Houd startpositie gecentreerd; begin pas met parallax als hero dichter bij de top komt.
				const approachStart = Math.max(viewportHeight * 0.28, 1);
				if (rect.top <= approachStart) {
					const approach = Math.max(0, Math.min((approachStart - rect.top) / approachStart, 1));
					progress = approach * 0.18;
				}
			} else {
				const inside = Math.max(0, -rect.top);
				progress = Math.min(0.18 + ((inside / Math.max(heroHeight * 0.95, 1)) * 0.82), 1);
			}

			const pinOffset = progress * maxPinOffset;
			const fadeProgress = rect.top < 0
				? Math.max(0, Math.min((-rect.top) / Math.max(heroHeight * 1.1, 1), 1))
				: 0;
			const opacity = Math.max(0.42, 1 - (fadeProgress * 0.7));

			contentBlock.style.transform = `translate3d(0, ${pinOffset.toFixed(2)}px, 0)`;
			contentBlock.style.opacity = opacity.toFixed(3);
		});
	};

	const requestUpdate = () => {
		if (!rafId) {
			rafId = window.requestAnimationFrame(update);
		}
	};

	window.addEventListener('scroll', requestUpdate, { passive: true });
	window.addEventListener('resize', requestUpdate);
	requestUpdate();
}
